// extracted by mini-css-extract-plugin
export default {"content":"styles_content__lX73T","spinnerBlock":"styles_spinnerBlock__hA9O1"};